/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * The well-known notification type keys. These are the single source of truth for every
 * <c>TypeKey</c> stamped on a notification, matched to an email template, or muted by a
 * notification setting. Exported to the frontend by TypeGen, so both sides share one definition.
 */
export class NotificationTypeKeys {
    /**
     * An invoice batch was created successfully. Dispatched transiently, so it is never persisted.
     */
    static readonly invoice_batch_succeeded: string = 'invoice_batch_succeeded';
    /**
     * An invoice batch creation failed.
     */
    static readonly invoice_batch_failed: string = 'invoice_batch_failed';
    /**
     * A container rent batch was booked. Dispatched transiently, so it is never persisted.
     */
    static readonly container_rent_batch_succeeded: string = 'container_rent_batch_succeeded';
    /**
     * A container rent batch failed. Dispatched transiently, so it is never persisted.
     */
    static readonly container_rent_batch_failed: string = 'container_rent_batch_failed';
    /**
     * A dynamic export failed.
     */
    static readonly dynamic_export_failed: string = 'dynamic_export_failed';
    /**
     * A dynamic export finished and produced its file.
     */
    static readonly dynamic_export_succeeded: string = 'dynamic_export_succeeded';
    /**
     * An external application secret is about to expire.
     */
    static readonly external_app_secret_expiry: string = 'external_app_secret_expiry';
    /**
     * The status of the portal user's requisition changed.
     */
    static readonly requisition_status_changed: string = 'requisition_status_changed';
    /**
     * An order was created for a requisition; notifies the operator.
     */
    static readonly requisition_received_operator: string = 'requisition_received_operator';
    /**
     * An attachment upload was rejected, either by the malware scan or by validation.
     */
    static readonly attachment_upload_failed: string = 'attachment_upload_failed';
    /**
     * An outgoing email could not be delivered.
     */
    static readonly email_not_delivered: string = 'email_not_delivered';
    /**
     * A new invoice became available to the portal user (Rechnungseingang).
     */
    static readonly invoice_received: string = 'invoice_received';
    /**
     * The user was logged out by the system. A functional SignalR signal, never user-visible.
     */
    static readonly user_logged_out: string = 'user_logged_out';
    /**
     * An archive was created and can be downloaded.
     */
    static readonly archive_ready: string = 'archive_ready';
    /**
     * An archive could not be created.
     */
    static readonly archive_failed: string = 'archive_failed';
    /**
     * A transient client cache invalidation hint (never persisted or emailed).
     */
    static readonly cache_invalidation: string = 'cache_invalidation';
}
